var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotePencilIcon = function SvgNotePencilIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#757D86",
    d: "m28.708 7.292-4-4a1 1 0 0 0-1.415 0l-12 12A1 1 0 0 0 11 16v4a1 1 0 0 0 1 1h4a1 1 0 0 0 .707-.293l12-12a1 1 0 0 0 0-1.415M15.586 19H13v-2.586l8-8L23.586 11zM25 9.586 22.414 7 24 5.414 26.586 8zM28 15v11a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h11a1 1 0 1 1 0 2H6v20h20V15a1 1 0 0 1 2 0"
  })));
};
export default SvgNotePencilIcon;